import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M91.83 48.06a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m17.12 31.67 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0L15 29.55l-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44L15 33.79l3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path fill="#0597A3" d="M37.25 8.35a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M103.32 65.61h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M18.07 15.85c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M50.97 95.75h-12c-2.88 0-5.22-2.34-5.22-5.22V22.67c0-2.88 2.34-5.22 5.22-5.22h36.54c2.88 0 5.22 2.34 5.22 5.22V89.7c0 3.34-2.71 6.05-6.05 6.05z"
    />
    <path
      fill="#0597A3"
      d="M57.34 64.86c8.87 0 16.06-7.19 16.06-16.06s-7.19-16.06-16.06-16.06-16.06 7.19-16.06 16.06 7.19 16.06 16.06 16.06"
    />
    <path
      fill="#001A43"
      d="M70.39 62.33a14.2 14.2 0 0 0-6.36-6.97 9.35 9.35 0 0 0 2.69-6.57c0-5.17-4.21-9.38-9.38-9.38s-9.38 4.21-9.38 9.38c0 2.56 1.03 4.89 2.71 6.58-2.98 1.6-5.38 4.24-6.6 7.53a2.247 2.247 0 0 0 2.1 3.03c.91 0 1.77-.56 2.11-1.47 1.4-3.77 5.04-6.3 9.06-6.3s7.39 2.32 8.91 5.91c.48 1.14 1.8 1.68 2.95 1.2 1.14-.48 1.68-1.8 1.2-2.95zM52.45 48.79c0-2.69 2.19-4.88 4.88-4.88s4.88 2.19 4.88 4.88-2.19 4.89-4.88 4.89-4.88-2.19-4.88-4.89M77.04 102.97c-.87.9-2.31.9-3.18 0L61.5 90.07a8.26 8.26 0 0 1-1.55-9.53 8.27 8.27 0 0 1 8.64-4.47c1.81.26 3.45 1.19 4.74 2.49l2.12 2.12 2.12-2.12c1.29-1.29 2.93-2.22 4.74-2.49a8.27 8.27 0 0 1 8.64 4.47c1.59 3.18.97 7.02-1.54 9.53z"
    />
  </svg>
);
const SvgEnrichedIconSocialMediaInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSocialMediaInverted);
export default Memo;
